import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, of, take } from 'rxjs';
import { GeneralService } from './general.service';
import {
  ApiResponseCatalog,
  ClosingFieldCatalogItem,
  ConnectivityType,
  WorkFlow,
} from '../models/catalogs/catalogs-model';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CatalogsService {
  public URL_API = environment.apiURLNew;

  constructor(
    private http: HttpClient,
    private generalService: GeneralService,
  ) {}

  public getConnectivityType(): Observable<ApiResponseCatalog<ConnectivityType[]> | null> {
    return this.http
      .get<ApiResponseCatalog<ConnectivityType[]>>(this.URL_API + `/api/ConnectivityType/List`, {})
      .pipe(
        take(1),
        catchError(() => {
          return of(null);
        }),
      );
  }

  public getWorkFlow(): Observable<ApiResponseCatalog<WorkFlow[]> | null> {
    return this.http
      .get<ApiResponseCatalog<WorkFlow[]>>(this.URL_API + `/api/WorkFlow/List`, {})
      .pipe(
        take(1),
        catchError(() => {
          return of(null);
        }),
      );
  }

  public getClosingFieldCatalog(
    path: string,
  ): Observable<ApiResponseCatalog<ClosingFieldCatalogItem[]> | null> {
    return this.http
      .get<ApiResponseCatalog<ClosingFieldCatalogItem[]>>(this.URL_API + path, {})
      .pipe(
        take(1),
        catchError(() => {
          return of(null);
        }),
      );
  }
}
